export default pageId => `
{
    manualsHub {
      getSidebarItems(page: ${pageId}) {
        id: termId
        name
      }
    }
}`;
